import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { Certificate } from './certificate.model';

export class CertificateStateModel extends EntityStateModel<Certificate> {}
